import React from "react";
import { Modal } from "@linkfluence/core/modal";
import { Locale } from "@linkfluence/models/locale";
import ModalContent from "@ui-kit/modal";
import { tr } from "@radarly/i18n";

export default function useNoCopyModal(
  setActiveCard: ({ position, idRow }) => void,
  locale: Locale,
  modalId: string
) {
  const { open, close, ModalWrapper } = Modal.get(modalId);

  const onOpenNoCopyModal = () => {
    setActiveCard({ position: null, idRow: null });
    open();
  };

  const NoCopyModal = () => (
    <ModalWrapper>
      <ModalContent
        title={tr(locale, `FILTER_PANEL::COPY_FILTERS`)}
        onCancel={() => close()}
        cancelLabel={tr(locale, "MODAL::CLOSE")}
        locale={locale}
        width="auto"
      >
        <p>{tr(locale, "INSIGHT_PAGES_EDITOR::NO_FILTERS_TO_COPY")}</p>
      </ModalContent>
    </ModalWrapper>
  );
  return {
    NoCopyModal,
    onOpenNoCopyModal,
  };
}
